<svelte:options runes={true} />

<script lang="ts">
  import { untrack } from "svelte";
  import Badge from "~/components/ui/Badge/Badge.svelte";
  import { badgeStore } from "~/lib/badges/store.svelte";

  interface Props {
    productId: string;
    hideDiscountBadge?: boolean;
  }

  let { productId, hideDiscountBadge = false }: Props = $props();

  $effect(() => {
    const id = productId;
    untrack(() => badgeStore.register(id));
  });

  const badge = $derived(badgeStore.results[productId]);
  const isLoaded = $derived(badgeStore.results[productId] !== undefined);
  const isSuppressed = $derived(hideDiscountBadge && badge?.type.toLowerCase() === "discount");
</script>

<span class="da-product-badge">
  {#if isLoaded && badge && !isSuppressed}
    <div class="da-product-badge__fade">
      <Badge text={badge.label} color={badge.color} icon={badge.icon} size={badge.size} as="div" />
    </div>
  {/if}
</span>

<style>
  @layer aurora {
    .da-product-badge {
      display: contents;
    }

    .da-product-badge__fade {
      opacity: 1;
      transition: opacity var(--da-duration-normal) var(--da-ease-out);

      @starting-style {
        opacity: 0;
      }
    }
  }
</style>
